import React from 'react';
import { addBreadcrumb, captureException } from '@sentry/browser';

/**
 * Logging to debug SLO burn in fedramp. Wrapped in component because we are
 * debugging the runtime value of a built-in react hook (useId).
 *
 * For detail see: https://hello.jira.atlassian.cloud/browse/KIRBY-10780
 */
const FedrampUseIdProbe = ({ context }: { context: string }) => {
  const value = React.useId?.();

  React.useEffect(() => {
    try {
      const valueType = typeof value;
      addBreadcrumb({
        level: 'info',
        message: 'FedRAMP React.useId probe',
        data: {
          context,
          reactVersion: React.version,
          useIdResultType: valueType,
          useIdResultConstructor: value && (value as any).constructor?.name,
          useIdResult: valueType === 'string' ? value : String(value),
          useId: React?.useId,
          useIdType: typeof React?.useId,
          useIdToString: React?.useId?.toString(),
        },
      });
    } catch (error) {
      captureException(error);
    }
  }, [context, value]);

  return null;
};

export default FedrampUseIdProbe;
